import axios from 'axios'

export const order = {
    state:{
        Orders:[],
        OrderById:{},
    },
    mutations:{
        SetOrders(state, data){
            state.Orders = data
        },
        SetOrderById(state, data){
            state.OrderById = data
        },
        CancelOrderById(state, ord){
            state.OrderById = ord
        },

    },
    actions:{
        GetOrders: ({commit}, payload) => {
            return new Promise((resolve, reject)=>{
            axios.get(`/allorder?type=${payload.type}`)
            .then(({data, status})=>{
                if(status === 200){
                console.log(data)                
                commit('SetOrders', data)
                resolve(data);
                }else if (status===204){
                    console.log('data empty')
                    let data = []
                    commit('SetOrders', data)
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },
        GetOrderById: ({commit},payload) => {
            return new Promise((resolve, reject)=>{
            axios.get("/itemsoffer/"+payload)
            .then(({data, status})=>{
                if(status === 200){
                console.log(data)                
                commit('SetOrderById', data)
                resolve(data);
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },
        ConfirmOrder: ({commit},payload) => {
            return new Promise((resolve, reject)=>{
            axios.post("/acceptoffer", payload)
            .then(({data, status})=>{
                if(status === 201){
                console.log(data)                
                commit('SetOrderById', data)
                resolve(data);
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        }, 
        ShopperCancelOrder: ({commit},payload) => {
            return new Promise((resolve, reject)=>{
            axios.get("/shoppercanceloffer/"+payload)
            .then(({data, status})=>{
                if(status === 200){
                    
                    resolve(data);
                    commit()
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },
        EarnerCancelOrder: ({commit},payload) => {
            return new Promise((resolve, reject)=>{
            axios.post("/earnercanceloffer", payload)
            .then(({data, status})=>{
                if(status === 200){
                    resolve(data);
                    commit()
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },
        ConfirmDelivery: ({commit},payload) => {
            return new Promise((resolve, reject)=>{
            axios.get("/confirmdelivery/"+payload)
            .then(({data, status})=>{
                if(status === 200){
                    resolve(data);
                    commit()
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },
        UpdateRead: ({commit},payload) => {
            return new Promise((resolve, reject)=>{
            axios.get("/markread/"+payload)
            .then(({data, status})=>{
                if(status === 200){
                    resolve(data);
                    commit()
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },  
        SendMessage: ({commit},payload) => {
            return new Promise((resolve, reject)=>{
            axios.post("/notification",payload)
            .then(({data, status})=>{
                if(status === 201){
                    resolve(data);
                    commit()
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },      
    }
}
